import bg from '../assets/i18n/bg';
import en from '../assets/i18n/en';

function Translate(key?: string) {

  if (typeof key === 'string') {
    let lang = localStorage.getItem('lang');
    if (!lang) {
      lang = 'bg';
      localStorage.setItem('lang', 'bg');
    }
    switch (lang) {
      case 'bg':
        return (bg[key] ? bg[key] : key);
      case 'en':
        return (en[key] ? en[key] : key);
    }
  } else {
    return key;
  }
}

export default Translate;
